import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from '@core/services/theme.service';
import { VersionCheckService } from '@core/services/version-check.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: `<router-outlet />`,
})
export class App {
  constructor() {
    // Inyectar ThemeService aquí garantiza que se inicialice (y aplique .dark) al arrancar
    inject(ThemeService);
    // TRANS-09: arranca el polling de /version.json en toda la app (login incluido,
    // no solo pantallas autenticadas) — ver VersionCheckService para el detalle.
    inject(VersionCheckService).start();
  }
}
